import React, { useState } from "react";
import "./Top.css";
import cake from "../Assets/cake.avif";
import { FaHeart } from "react-icons/fa";
import shape from '../Assets/shape.png'

const Top = () => {
  const [addedToCart, setAddedToCart] = useState(false);

  const handleOrderClick = () => {
    setAddedToCart(true);
    setTimeout(() => setAddedToCart(false), 2000); // Reset after 2 seconds
  };

  return (
    <div className="cookie-container">
      <div className="cookie-image">
        <img src={cake} alt="Wildberry Sugar Cookie" />
      </div>
      <div className="cookie-details">
        <h1 className="cookie-name">Wildberry Sugar</h1>
        <p className="cookie-description">
          A warm vanilla sugar cookie packed with strawberries and blueberries.
        </p>
        <div className="buttons">
          <button className="order-btn" onClick={handleOrderClick}>
            {addedToCart ? "Added to Cart" : "Order Now"}
          </button>
          <button className="favorite-btn">
            <FaHeart /> Add To Favorites
          </button>
        </div>
        <div className="rating">
          ⭐⭐⭐⭐☆ <span className="avg-rating">4.15 avg rating</span> | 12,188 reviews
        </div>
      </div>
      
    </div>
  );
};

export default Top;
